import '../styles/login.css';
import { useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { auth } from "./firebase";
import { GoogleSignIn } from "./GoogleSignIn";

export const Login = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // Само пътища в сайта – иначе ?next= става пренасочване към чужд адрес.
  const next = /^\/(?!\/)/.test(params.get('next') || '') ? params.get('next') : null;
  const [errorMessage, setErrorMessage] = useState(null);
  const [infoMessage, setInfoMessage] = useState(null);
  const emailInput = useRef(null);

  const onSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;

    setInfoMessage(null);
    auth.signInWithEmailAndPassword(email, password)
      .then(() => {
        navigate(next || '/catalog');
      })
      .catch(() => {
        setErrorMessage("Невалиден имейл или парола");
      });
  };

  const onForgot = () => {
    const email = emailInput.current.value.trim();
    setInfoMessage(null);
    if (!emailInput.current.checkValidity() || !email) {
      setErrorMessage("Въведете имейла си и натиснете отново „Забравена парола?“");
      emailInput.current.focus();
      return;
    }
    setErrorMessage(null);
    auth.languageCode = 'bg';
    const sent = () => setInfoMessage(`Ако има акаунт с ${email}, изпратихме писмо с линк за нова парола. Проверете и папка „Спам“.`);
    auth.sendPasswordResetEmail(email)
      .then(sent)
      .catch((error) => {
        // Като при входа: не казваме дали имейлът е регистриран.
        if (error.code === 'auth/user-not-found') { sent(); return; }
        setErrorMessage(error.code === 'auth/too-many-requests'
          ? "Твърде много опити. Опитайте отново след малко."
          : "Писмото не беше изпратено. Опитайте отново.");
      });
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <h2>Stamsy Art</h2>
          <p>Ръчно рисувани дрехи и подаръци</p>
        </div>
        <h3 className="auth-title">Вход в акаунта</h3>
        {errorMessage && <div className="auth-error">{errorMessage}</div>}
        {infoMessage && <div className="auth-info">{infoMessage}</div>}
        <GoogleSignIn onSignedIn={() => navigate(next || '/catalog')} />
        <div className="auth-or"><span>или</span></div>
        <form onSubmit={onSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="email">Имейл</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="вашият@имейл.com"
              ref={emailInput}
              required
            />
          </div>
          <div className="auth-field">
            <label htmlFor="password">Парола</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="••••••••"
              required
            />
            <button type="button" className="auth-forgot" onClick={onForgot}>Забравена парола?</button>
          </div>
          <button type="submit" className="auth-btn">Вход</button>
        </form>
        <p className="auth-switch">
          Нямате акаунт? <Link to={next ? `/register?next=${encodeURIComponent(next)}` : "/register"}>Регистрация</Link>
        </p>
      </div>
    </div>
  );
};
